// Images
export const images = {
  cta: require('./images/CTA.png'),
  home: require('./images/home.jpg'),
  logo: require('./images/logo.svg'),
  logo_small: require('./images/logo-small.svg'),
  phones: require('./images/phones.png'),
  overview: require('./images/overview.png'),
  howItWorks: require('./images/how-it-works.jpg'),
  connect: require('./images/connect.svg'),
  heal: require('./images/heal.svg'),
  track: require('./images/track.svg'),
  ctaLight: require('./images/cta-light.png'),
  favouriteArtists: require('./images/favourite-artists.jpg'),
  phone0: require('./images/phone0.png'),
  phone1: require('./images/phone1.png'),
  phone2: require('./images/phone2.png'),
  phone3: require('./images/phone3.png'),
  phone4: require('./images/phone4.png'),
  phone5: require('./images/phone5.png'),
  phone6: require('./images/phone6.png'),
  arrowLeft: require('./images/arrow-left.png'),
  arrowRight: require('./images/arrow-right.png'),
  arrowLeftMobile: require('./images/arrow-left-mobile.png'),
  arrowRightMobile: require('./images/arrow-right-mobile.png'),
  howYouFeel: require('./images/how-you-feel.jpg'),
  breakthrough: require('./images/breakthrough.png'),
  breakthroughSmall: require('./images/breakthrough-small.png'),
  backToWebCta: require('./images/back-to-web-cta.png'),
  // Add image exports here
  // example: logo: require('./images/logo.png'),
} as const;

// You can add other asset categories here
// export const videos = {} as const;
// export const icons = {} as const;
// export const fonts = {} as const; 